import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DebugProvider } from "helpers/debug";
import type { AppProps } from "next/app";
import { useEffect } from "react";
import { CloudinaryProvider } from "react-tiny-cloudinary";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
            cacheTime: 0,
        },
    },
});

function MyApp({ Component, pageProps, err }: AppProps & { err: any }) {
    // Workaround to conditionally load global css.
    useEffect(() => {
        process.env.NEXT_PUBLIC_SITE_THEME === "schaub"
            ? require("../styles/schaub/globals.scss")
            : require("../styles/emtek/globals.scss");

        require("../styles/globals.scss");
    }, []);

    // Workaround for https://github.com/vercel/next.js/issues/8592
    return (
        <DebugProvider>
            <CloudinaryProvider
                cloudName={process.env.NEXT_PUBLIC_CLOUDINARY_NAME || "emtek"}
                defaultTransformation={{
                    defaultImage: "product-placeholder.jpg",
                    dpr: "auto",
                    fetchFormat: "auto",
                    quality: "auto",
                }}
            >
                <QueryClientProvider client={queryClient}>
                    <Component {...pageProps} err={err} />
                </QueryClientProvider>
            </CloudinaryProvider>
        </DebugProvider>
    );
}

export default MyApp;
